/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  TextField,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  CircularProgress,
  Chip,
  InputAdornment,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import SearchIcon from "@material-ui/icons/Search";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import RefreshIcon from "@material-ui/icons/Refresh";
import { SalaryService } from "_services/salary.service";

const useStyles = makeStyles(theme => ({
  cardHeader: {
    backgroundColor: "#f5f5f5",
    padding: "16px",
    borderBottom: "1px solid #e0e0e0"
  },
  tableHeader: {
    backgroundColor: "#eceff1",
    fontWeight: "bold"
  },
  tableRow: {
    "&:nth-of-type(even)": {
      backgroundColor: "#fafafa"
    },
    "&:hover": {
      backgroundColor: "#f0f4f8"
    }
  },
  inactiveRow: {
    backgroundColor: "#fbe9e7 !important",
    opacity: 0.75
  }
}));

export default function SalaryEmployeeManager({
  banks = [],
  typeGovList = [],
  onEmployeeChanged
}) {
  const classes = useStyles();
  const [localTypeGovList, setLocalTypeGovList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [savingUser, setSavingUser] = useState(null);
  const [persons, setPersons] = useState([]);
  const [typeGov, setTypeGov] = useState(0);
  const [search, setSearch] = useState("");

  const activeTypeGovList = typeGovList && typeGovList.length > 0 ? typeGovList : localTypeGovList;

  // If typeGovList is not passed, fetch from table typegov via API
  useEffect(() => {
    if (!typeGovList || typeGovList.length === 0) {
      SalaryService.getTypeGov()
        .then(res => {
          const raw = res.data?.data || (Array.isArray(res.data) ? res.data : []);
          if (Array.isArray(raw) && raw.length > 0) {
            setLocalTypeGovList(
              raw.map(t => ({
                key: t.typeGovKey || t.TypeGovKey || t.key,
                name: t.name || t.Name,
                code: t.code || t.Code
              }))
            );
          }
        })
        .catch(err => console.error("Error loading typeGov in EmployeeManager:", err));
    }
  }, [typeGovList]);

  // Add Employee Dialog
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [loadingUnmapped, setLoadingUnmapped] = useState(false);
  const [unmappedEmployees, setUnmappedEmployees] = useState([]);
  const [selectedNewUser, setSelectedNewUser] = useState("");
  const [newBankID, setNewBankID] = useState("");
  const [newAccountNo, setNewAccountNo] = useState("");
  const [newIsActive, setNewIsActive] = useState(true);
  const [savingNew, setSavingNew] = useState(false);

  useEffect(() => {
    loadPersons();
  }, [typeGov]);

  const loadPersons = async () => {
    setLoading(true);
    try {
      const res = await SalaryService.getSalaryPersons(typeGov, search);
      if (res.data && res.data.success) {
        setPersons(res.data.data || []);
      }
    } catch (err) {
      console.error("Error loading salary persons:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleBankChange = (userName, bankId) => {
    setPersons(prev =>
      prev.map(p =>
        p.userName === userName ? { ...p, bankID: bankId ? Number(bankId) : null } : p
      )
    );
  };

  const handleAccountChange = (userName, accNo) => {
    setPersons(prev =>
      prev.map(p => (p.userName === userName ? { ...p, accountNo: accNo } : p))
    );
  };

  const handleToggleActive = async (userName, newStatus) => {
    try {
      const res = await SalaryService.toggleSalaryPersonActive(userName, newStatus);
      if (res.data && res.data.success) {
        setPersons(prev =>
          prev.map(p => (p.userName === userName ? { ...p, isActive: newStatus } : p))
        );
        if (onEmployeeChanged) onEmployeeChanged();
      } else {
        alert(res.data?.message || "ไม่สามารถเปลี่ยนสถานะได้");
      }
    } catch (err) {
      console.error("Error toggling active:", err);
      alert("เกิดข้อผิดพลาดในการเปลี่ยนสถานะ");
    }
  };

  const handleSavePerson = async person => {
    setSavingUser(person.userName);
    try {
      const payload = {
        userName: person.userName,
        bankID: person.bankID,
        accountNo: person.accountNo,
        isActive: person.isActive
      };
      const res = await SalaryService.saveSalaryPersonConfig(payload);
      if (res.data && res.data.success) {
        alert(`บันทึกข้อมูลบัญชีของ ${person.fullName} เรียบร้อยแล้ว`);
        if (onEmployeeChanged) onEmployeeChanged();
      } else {
        alert(res.data?.message || "เกิดข้อผิดพลาดในการบันทึก");
      }
    } catch (err) {
      console.error("Error saving person config:", err);
      alert("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
    } finally {
      setSavingUser(null);
    }
  };

  // Open Add Employee Dialog
  const handleOpenAddDialog = async () => {
    setSelectedNewUser("");
    setNewBankID("");
    setNewAccountNo("");
    setNewIsActive(true);
    setAddDialogOpen(true);
    setLoadingUnmapped(true);
    try {
      const res = await SalaryService.getUnmappedEmployees();
      if (res.data && res.data.success) {
        setUnmappedEmployees(res.data.data || []);
      }
    } catch (err) {
      console.error("Error loading unmapped employees:", err);
    } finally {
      setLoadingUnmapped(false);
    }
  };

  const handleSaveNewEmployee = async () => {
    if (!selectedNewUser) {
      alert("กรุณาเลือกเจ้าหน้าที่");
      return;
    }
    setSavingNew(true);
    try {
      const payload = {
        userName: selectedNewUser,
        bankID: newBankID ? Number(newBankID) : null,
        accountNo: newAccountNo ? newAccountNo.trim() : "",
        isActive: newIsActive
      };

      const res = await SalaryService.saveSalaryPersonConfig(payload);
      if (res.data && res.data.success) {
        alert("เพิ่มเจ้าหน้าที่และผูกบัญชีธนาคารเรียบร้อยแล้ว");
        setAddDialogOpen(false);
        loadPersons();
        if (onEmployeeChanged) onEmployeeChanged();
      } else {
        alert(res.data?.message || "เกิดข้อผิดพลาดในการบันทึก");
      }
    } catch (err) {
      console.error("Error saving new employee:", err);
      alert("เกิดข้อผิดพลาดในการบันทึก");
    } finally {
      setSavingNew(false);
    }
  };

  const filteredPersons = persons.filter(p => {
    if (!search) return true;
    const s = search.toLowerCase();
    return (
      (p.fullName && p.fullName.toLowerCase().includes(s)) ||
      (p.userName && p.userName.toLowerCase().includes(s)) ||
      (p.cid && p.cid.includes(s)) ||
      (p.positionName && p.positionName.toLowerCase().includes(s)) ||
      (p.accountNo && p.accountNo.includes(s))
    );
  });

  return (
    <Card variant="outlined">
      <div className={classes.cardHeader}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              placeholder="ค้นหาชื่อ, สกุล, ตำแหน่ง, เลขบัญชี..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                )
              }}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              select
              fullWidth
              size="small"
              variant="outlined"
              label="กลุ่มประเภทบุคลากร"
              value={typeGov}
              onChange={e => setTypeGov(Number(e.target.value))}
            >
              <MenuItem value={0}>ทั้งหมด</MenuItem>
              {activeTypeGovList.map(t => (
                <MenuItem key={t.key} value={t.key}>
                  {t.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6} style={{ textAlign: "right" }}>
            <Box display="flex" justifyContent="flex-end" gap={1}>
              <Button
                variant="outlined"
                color="primary"
                startIcon={<RefreshIcon />}
                onClick={loadPersons}
                disabled={loading}
              >
                รีเฟรช
              </Button>
              <Button
                variant="contained"
                color="primary"
                startIcon={<PersonAddIcon />}
                onClick={handleOpenAddDialog}
              >
                เพิ่มเจ้าหน้าที่ในระบบเงินเดือน
              </Button>
            </Box>
          </Grid>
        </Grid>
      </div>

      <CardContent>
        {loading ? (
          <Box py={6} textAlign="center">
            <CircularProgress />
            <Typography style={{ marginTop: 8 }}>กำลังโหลดรายชื่อบุคลากร...</Typography>
          </Box>
        ) : (
          <TableContainer component={Paper} variant="outlined" style={{ maxHeight: 600 }}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHeader} width={50} align="center">
                    ลำดับ
                  </TableCell>
                  <TableCell className={classes.tableHeader}>ชื่อ - สกุล</TableCell>
                  <TableCell className={classes.tableHeader}>เลขบัตรประชาชน (CID)</TableCell>
                  <TableCell className={classes.tableHeader}>ตำแหน่ง / หน่วยงาน</TableCell>
                  <TableCell className={classes.tableHeader}>กลุ่มบุคลากร</TableCell>
                  <TableCell className={classes.tableHeader} width={200}>
                    ธนาคาร
                  </TableCell>
                  <TableCell className={classes.tableHeader} width={180}>
                    เลขที่บัญชี
                  </TableCell>
                  <TableCell className={classes.tableHeader} width={120} align="center">
                    สถานะใช้งาน
                  </TableCell>
                  <TableCell className={classes.tableHeader} width={100} align="center">
                    จัดการ
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredPersons.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center" style={{ padding: 32 }}>
                      ไม่พบข้อมูลบุคลากรในตาราง SalaryPerson (กดปุ่ม "เพิ่มเจ้าหน้าที่ในระบบเงินเดือน" เพื่อเลือกและผูกบัญชีพนักงาน)
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredPersons.map((p, idx) => (
                    <TableRow
                      key={p.userName}
                      className={`${classes.tableRow} ${!p.isActive ? classes.inactiveRow : ""}`}
                    >
                      <TableCell align="center">{idx + 1}</TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        {p.fullName}
                        <Typography variant="caption" color="textSecondary" display="block">
                          User: {p.userName}
                        </Typography>
                      </TableCell>
                      <TableCell>{p.cid || "-"}</TableCell>
                      <TableCell>
                        <Typography variant="body2">{p.positionName || "-"}</Typography>
                        <Typography variant="caption" color="textSecondary">
                          {p.departmentName || "-"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip label={p.typeGovName || "-"} size="small" variant="outlined" />
                      </TableCell>
                      <TableCell>
                        <TextField
                          select
                          fullWidth
                          size="small"
                          variant="outlined"
                          value={p.bankID || ""}
                          onChange={e => handleBankChange(p.userName, e.target.value)}
                        >
                          <MenuItem value="">-- ไม่ระบุ --</MenuItem>
                          {banks.map(b => (
                            <MenuItem key={b.bankID} value={b.bankID}>
                              {b.bankName}
                            </MenuItem>
                          ))}
                        </TextField>
                      </TableCell>
                      <TableCell>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          placeholder="เลขที่บัญชีธนาคาร"
                          value={p.accountNo || ""}
                          onChange={e => handleAccountChange(p.userName, e.target.value)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Box display="flex" flexDirection="column" alignItems="center">
                          <Switch
                            checked={Boolean(p.isActive)}
                            onChange={e => handleToggleActive(p.userName, e.target.checked)}
                            color="primary"
                            size="small"
                          />
                          {p.isActive ? (
                            <Chip
                              label="ใช้งาน"
                              size="small"
                              style={{
                                backgroundColor: "#e8f5e9",
                                color: "#2e7d32",
                                fontSize: "0.75rem",
                                height: 20
                              }}
                            />
                          ) : (
                            <Chip
                              label="ปิดใช้งาน"
                              size="small"
                              style={{
                                backgroundColor: "#ffebee",
                                color: "#c62828",
                                fontSize: "0.75rem",
                                height: 20
                              }}
                            />
                          )}
                        </Box>
                      </TableCell>
                      <TableCell align="center">
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          startIcon={<SaveIcon />}
                          disabled={savingUser === p.userName}
                          onClick={() => handleSavePerson(p)}
                        >
                          {savingUser === p.userName ? "..." : "บันทึก"}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>

      {/* Add Employee Dialog */}
      <Dialog
        open={addDialogOpen}
        onClose={() => setAddDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ backgroundColor: "#1976d2", color: "#fff" }}>
          เพิ่มเจ้าหน้าที่เข้าสู่ระบบเงินเดือน (Mapping)
        </DialogTitle>
        <DialogContent dividers>
          {loadingUnmapped ? (
            <Box py={4} textAlign="center">
              <CircularProgress />
              <Typography style={{ marginTop: 8 }}>กำลังโหลดรายชื่อเจ้าหน้าที่ที่ยังไม่มีข้อมูล...</Typography>
            </Box>
          ) : (
            <Box py={1}>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                เลือกเจ้าหน้าที่ที่ยังไม่มีประวัติในตารางเงินเดือน (SalaryPerson) เพื่อกำหนดธนาคารและเลขที่บัญชี:
              </Typography>

              <Box my={2}>
                <TextField
                  select
                  fullWidth
                  required
                  variant="outlined"
                  size="small"
                  label="เลือกเจ้าหน้าที่"
                  value={selectedNewUser}
                  onChange={e => setSelectedNewUser(e.target.value)}
                  helperText={
                    unmappedEmployees.length === 0
                      ? "เจ้าหน้าที่ทุกคนถูกเพิ่มเข้าสู่ระบบเงินเดือนครบแล้ว"
                      : `พบ ${unmappedEmployees.length} คนที่ยังไม่มีข้อมูลในระบบเงินเดือน`
                  }
                >
                  <MenuItem value="">-- กรุณาเลือกเจ้าหน้าที่ --</MenuItem>
                  {unmappedEmployees.map(u => (
                    <MenuItem key={u.userName} value={u.userName}>
                      {u.fullName} ({u.positionName || "ไม่ระบุตำแหน่ง"}) - {u.typeGovName || "-"}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>

              <Box my={2}>
                <TextField
                  select
                  fullWidth
                  variant="outlined"
                  size="small"
                  label="ธนาคาร"
                  value={newBankID}
                  onChange={e => setNewBankID(e.target.value)}
                >
                  <MenuItem value="">-- เลือกธนาคาร --</MenuItem>
                  {banks.map(b => (
                    <MenuItem key={b.bankID} value={b.bankID}>
                      {b.bankName}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>

              <Box my={2}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  label="เลขที่บัญชีธนาคาร"
                  placeholder="เช่น 901-2-34567-8"
                  value={newAccountNo}
                  onChange={e => setNewAccountNo(e.target.value)}
                />
              </Box>

              <Box my={1}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={newIsActive}
                      onChange={e => setNewIsActive(e.target.checked)}
                      color="primary"
                    />
                  }
                  label={
                    <Typography variant="body2" style={{ fontWeight: "bold" }}>
                      เปิดใช้งานในระบบเงินเดือนทันที (Active)
                    </Typography>
                  }
                />
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddDialogOpen(false)} startIcon={<CloseIcon />}>
            ยกเลิก
          </Button>
          <Button
            onClick={handleSaveNewEmployee}
            color="primary"
            variant="contained"
            startIcon={savingNew ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
            disabled={savingNew || !selectedNewUser || loadingUnmapped}
          >
            {savingNew ? "กำลังบันทึก..." : "บันทึกและเพิ่มเข้าสู่ระบบ"}
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
}
